// extracted by mini-css-extract-plugin
module.exports = {"picWrapper":"hVTwz","pic":"_3EGlL","emptyPic":"GrFJ7","picWrapperAnimated":"_1c8vY"};